/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_TurkishInputs */

const en_speechmatics_target_language_turkish = /** @type {(inputs: Speechmatics_Target_Language_TurkishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turkish`)
};

const fr_speechmatics_target_language_turkish = /** @type {(inputs: Speechmatics_Target_Language_TurkishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turc`)
};

const de_speechmatics_target_language_turkish = /** @type {(inputs: Speechmatics_Target_Language_TurkishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkisch`)
};

const it_speechmatics_target_language_turkish = /** @type {(inputs: Speechmatics_Target_Language_TurkishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`turco`)
};

const ru_speechmatics_target_language_turkish = /** @type {(inputs: Speechmatics_Target_Language_TurkishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`турецкий`)
};

const es_speechmatics_target_language_turkish = /** @type {(inputs: Speechmatics_Target_Language_TurkishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`turco`)
};

const zh_cn2_speechmatics_target_language_turkish = /** @type {(inputs: Speechmatics_Target_Language_TurkishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`土耳其`)
};

const ja_speechmatics_target_language_turkish = /** @type {(inputs: Speechmatics_Target_Language_TurkishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トルコ語`)
};

const hi_speechmatics_target_language_turkish = /** @type {(inputs: Speechmatics_Target_Language_TurkishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तुर्की`)
};

const pt_pt2_speechmatics_target_language_turkish = /** @type {(inputs: Speechmatics_Target_Language_TurkishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`turco`)
};

/**
* | output |
* | --- |
* | "Turkish" |
*
* @param {Speechmatics_Target_Language_TurkishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_turkish = /** @type {((inputs?: Speechmatics_Target_Language_TurkishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_TurkishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_turkish(inputs)
	if (locale === "de") return de_speechmatics_target_language_turkish(inputs)
	if (locale === "it") return it_speechmatics_target_language_turkish(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_turkish(inputs)
	if (locale === "es") return es_speechmatics_target_language_turkish(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_turkish(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_turkish(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_turkish(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_turkish(inputs)
	return en_speechmatics_target_language_turkish(inputs)
});